import { FormItemProps, message, Tooltip, UploadFile } from "antd";
import { isEmpty, isUndefined } from "lodash";
import { strings } from "utils/localizedStrings";

export const createFormRules = (
  stricted: boolean,
  dataType: string,
  message: string
) => {
  return [
    {
      required: stricted,
      type: dataType,
      message: message,
    },
  ] as FormItemProps["rules"];
};

export const getFormInitialVals = <O extends Object>(
  data: O,
  value: keyof O
) => {
  if (!isEmpty(data)) {
    return data[value];
  } else {
    return undefined;
  }
};

export const getMessage = (
  info: string,
  time: number,
  type: "success" | "error" | "warning"
) => {
  switch (type) {
    case "success":
      return message.success({
        content: info,
        duration: time,
      });
    case "error":
      return message.error({
        content: info,
        duration: time,
      });
    case "warning":
      return message.warning({
        content: info,
        duration: time,
      });
  }
};

export const renderStatus = (value: unknown) => {
  switch (value) {
    case "active":
      return (
        <span className="font-semibold text-green-700">
          {strings.GlobalLabels.Active}
        </span>
      );
    case "inactive":
      return (
        <span className="font-semibold text-red-700">
          {strings.GlobalLabels.Inactive}
        </span>
      );
    case 0:
      return (
        <span className="font-semibold text-green-700">
          {strings.GlobalLabels.Active}
        </span>
      );
    case 1:
      return (
        <span className="font-semibold text-red-700">
          {strings.GlobalLabels.Inactive}
        </span>
      );
    case -1:
      return (
        <span className="font-semibold text-red-700">
          {strings.GlobalLabels.Inactive}
        </span>
      );
  }
};
export const convertToISO = (dateStr: {
  $y: number;
  $M: number;
  $D: number;
}) => {
  const year = dateStr.$y;
  const month = dateStr.$M + 1;
  const day = dateStr.$D;
  const isoDate = `${year.toString().padStart(4, "0")}-${month
    .toString()
    .padStart(2, "0")}-${day.toString().padStart(2, "0")}T00:00:00.000Z`;
  return isoDate;
};

export const getUserType = (value: string) => {
  switch (value) {
    case "user":
      return <span style={{ color: "#473b3b", fontWeight: 700 }}>User</span>;
    case "admin":
      return <span style={{ color: "#180d7a", fontWeight: 700 }}>Admin</span>;
    case "partner":
      return <span style={{ color: "#650d7a", fontWeight: 700 }}>Partner</span>;
  }
};

export const getUserStatus = (value: number) => {
  switch (value) {
    case 0:
      return (
        <span style={{ color: "#32a852", fontWeight: 700 }}>
          {strings.GlobalLabels.Active}
        </span>
      );
    case 1:
      return (
        <span style={{ color: "#b37f27", fontWeight: 700 }}>
          {strings.GlobalLabels.Inactive}
        </span>
      );
    case 2:
      return (
        <span style={{ color: "#ab1111", fontWeight: 700 }}>
          {strings.GlobalLabels.Deleted}
        </span>
      );
  }
};

export const getStatus = (value: number) => {
  switch (value) {
    case 0:
      return (
        <span style={{ color: "#d9a61c", fontWeight: 700 }}>Khởi tạo</span>
      );
    case 1:
      return (
        <span style={{ color: "#2029a8", fontWeight: 700 }}>Đang xử lý</span>
      );
    case 2:
      return (
        <span style={{ color: "green", fontWeight: 700 }}>Hoàn thành</span>
      );
    case 3:
      return <span style={{ color: "red", fontWeight: 700 }}>Lỗi</span>;
    case 4:
      return <span style={{ color: "#730d34", fontWeight: 700 }}>Đã xóa</span>;
    case 5:
      return (
        <span style={{ color: "#c79712", fontWeight: 700 }}>Chờ xác nhận</span>
      );
    default:
      return "";
  }
};

export const statusForContent = (value: number) => {
  switch (value) {
    case 0:
      return <span className="text-green-600 font-bold">Hoạt động</span>;
    case 1:
      return <span className="text-red-700 font-bold">Không hoạt động</span>;
    default:
      return "";
  }
};

export const statusForSimApplication = (value: number) => {
  switch (value) {
    case 10:
      return "Chờ thanh toán";
    case 11:
      return "Chờ giao hàng";
    case 12:
      return "Chờ nhận hàng";
    case 13:
      return "Giao hàng thành công";
    case 14:
      return "Đã hủy";
    case 15:
      return "Đã hòa mạng";
    case 16:
      return "Hòa mạng thất bại";
    default:
      return "";
  }
};

export const statusForDetails = (value: number) => {
  switch (value) {
    case 0:
      return "Khởi tạo";
    case 1:
      return "Đang xử lý";
    case 2:
      return "Hoàn thành";
    case 3:
      return "Lỗi";
    case 4:
      return "Đã xóa";
    case 5:
      return "Chờ xác nhận";
    default:
      return "";
  }
};

export const formatCurrency = (value: string | number) => {
  return (
    <span
      style={{
        fontWeight: 550,
        color:
          (value as number) > 0 || parseInt(value as string) > 0
            ? "green"
            : "red",
      }}
    >
      {`${new Intl.NumberFormat().format(
        typeof value === "string" ? parseInt(value) : value
      )} VND`}
    </span>
  );
};

export const DataFormater = (number: number) => {
  if (number >= 1000000000) {
    return (number / 1000000000).toString() + "B";
  } else if (number >= 1000000) {
    return (number / 1000000).toString() + "M";
  } else if (number >= 1000) {
    return (number / 1000).toString() + "K";
  } else {
    return number.toString();
  }
};

export const autoCorrectJSON = (jsonString: string): string => {
  let correctedJSON = jsonString
    .replace(/(?<=\{|\,)\s*([\w]+)\s*:/g, '"$1":')
    .replace(/(?<=:)\s*'([^']*)'\s*(?=,|\}|$)/g, ' "$1"');
  correctedJSON = correctedJSON.replace(/,\s*([\]}])/g, "$1");
  return correctedJSON;
};

export const paramsChecking = <T extends unknown>(
  value: T | undefined,
  type: "select" | "input"
) => {
  switch (type) {
    case "select":
      return value === strings.GlobalLabels.All ? undefined : value;
    case "input":
      return isEmpty(value) || isUndefined(value) ? undefined : value;
  }
};

export const avoidDuplicate = <T extends string | number | boolean | Object>(
  baseInfo: T,
  newInfo: typeof baseInfo
) => {
  if (newInfo === baseInfo) {
    return undefined;
  } else {
    return newInfo;
  }
};
